import { createFileRoute } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { seo, toDescription } from "@/lib/seo";
import ProjectDetail from "@/pages/ProjectDetail";

export const Route = createFileRoute("/_site/projects/$slug")({
  loader: async ({ params }) => {
    const { data } = await supabase
      .from("projects")
      .select("*")
      .eq("slug", params.slug)
      .eq("published", true)
      .maybeSingle();
    return { project: data ?? null };
  },
  head: ({ loaderData, params }) => {
    const project = loaderData?.project;
    if (!project) return {};
    return seo({
      title: `${project.title} | Kodiak Structures & Exteriors`,
      description: toDescription(project.description || ""),
      path: `/projects/${params.slug}`,
      image: project.image_url,
      type: "article",
    });
  },
  component: ProjectDetail,
});
